export function ProfileUserOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.6751 3.33335C15.2917 3.33335 16.5917 4.64169 16.5917 6.25002C16.5917 7.82502 15.3417 9.10835 13.7834 9.16669C13.7167 9.15835 13.6417 9.15835 13.5667 9.16669M15.2834 16.6667C15.8834 16.5417 16.4501 16.3 16.9167 15.9417C18.2167 14.9667 18.2167 13.3584 16.9167 12.3834C16.4584 12.0334 15.9001 11.8 15.3084 11.6667M7.63339 9.05835C7.55006 9.05002 7.45006 9.05002 7.35839 9.05835C5.37506 8.99169 3.80006 7.36669 3.80006 5.36669C3.80006 3.32502 5.45006 1.66669 7.50006 1.66669C9.54172 1.66669 11.2001 3.32502 11.2001 5.36669C11.1917 7.36669 9.61672 8.99169 7.63339 9.05835ZM3.46672 12.1334C1.45006 13.4834 1.45006 15.6834 3.46672 17.025C5.75839 18.5584 9.51672 18.5584 11.8084 17.025C13.8251 15.675 13.8251 13.475 11.8084 12.1334C9.52506 10.6084 5.76672 10.6084 3.46672 12.1334Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
